<template>
  <div class="row m-0 sidebar_menu py-5 py-lg-0" v-if="shopDetails">
    <div class="col-12 py-3 px-0">
      <div class="row m-0 d-none d-lg-flex justify-content-center">
        <div class="col-11 text-center">
          <img :src="shopDetails.logo" v-if="shopDetails.logo" class="logo img-fluid"/>
          <span v-else>{{ shopDetails.name }}</span>
        </div>
      </div>
      <div class="row m-0 mt-1">
        <div class="col-12 pointer">
          <div class="row m-0">
            <div class="col-11 p-0 truncate text-center">
              <a target="_blank" :href="`https://${shopId}.thehoods.app/`">{{ shopId }}</a>
            </div>
            <div class="col-1 p-0 material-icons small_text text-right">
              open_in_new
            </div>
          </div>
        </div>
      </div>
      <div class="row m-0 mt-3">
        <div class="col-12 py-2" v-if="isLoggedIn" :class="{active: currentPath == '/'}">
          <router-link @click.native="toggleNavbar" to="/">
            Orders
          </router-link>
        </div>
        <div class="col-12 py-2" v-if="isLoggedIn" :class="{active: currentPath == '/products'}">
          <router-link @click.native="toggleNavbar" to="/products">
            Products
          </router-link>
        </div>
        <div class="col-12 py-2" v-if="isLoggedIn" :class="{active: currentPath == '/categories'}">
          <router-link @click.native="toggleNavbar" to="/categories">
            Product Categories
          </router-link>
        </div>
        <div class="col-12 py-2" v-if="isLoggedIn" :class="{active: currentPath == '/shop'}">
          <router-link @click.native="toggleNavbar" to="/shop">
            Shop Settings
          </router-link>
        </div>
        <!-- <div class="col-12 py-2" v-if="isLoggedIn" :class="{active: currentPath == '/billing'}">
          <router-link @click.native="toggleNavbar" to="/billing">
            Billing
          </router-link>
        </div> -->
        <div class="col-12 py-2" v-if="isLoggedIn" :class="{active: currentPath == '/customers'}">
          <router-link @click.native="toggleNavbar" to="/customers">
            Customers
          </router-link>
        </div>
        <div class="col-12 py-2" v-if="isLoggedIn" :class="{active: currentPath == '/report'}">
          <router-link @click.native="toggleNavbar" to="/report">
            Report
          </router-link>
        </div>
        <div class="col-12 py-2" v-if="isLoggedIn" >
          <a @click="toggleNotification" class="relative pointer">
            Community
            <div class="notification" v-if="hasNotification"></div>
          </a>
        </div>
        <!-- <div class="col-12 py-2" v-if="isLoggedIn" :class="{active: currentPath == '/drivers'}">
          <router-link @click.native="toggleNavbar" to="/drivers">
            Drivers
          </router-link>
        </div> -->
      </div>
    </div>
    <div class="col-12 text-center p-3 pointer align-self-end logout mb-5 mb-md-0" v-if="isLoggedIn" @click="logout">
      <div class="row m-0 justify-content-center h-100">
        <div class="col-auto p-0 h-100">
          <div class="row m-0 h-100 align-items-center">
            <div class="col-auto p-0 material-icons">logout</div>
            <div class="col-auto pl-1 pr-0">Logout</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions, mapGetters
} from 'vuex'
export default {
  data () {
    return {
      isNavOpen: false,
      isPending: true,
      hasNotification: true
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'currentUser', 'shopDetails', 'shopId', 'isShopLoading']),
    userEmail () {
      return this.isLoggedIn ? this.currentUser.email : ''
    },
    currentPath () {
      return this.$route.path
    }
  },
  methods: {
    ...mapActions(['logout']),
    toggleNavbar () {
      this.$emit('toggleNavbar')
    },
    toggleNotification () {
      window.open('https://hoods.tribe.so/group/hoods-startup', '_blank')
      this.hasNotification = false
    }
  }
}
</script>

<style scoped>
.sidebar_menu {
  background-color: var(--light-color);
  color: var(--dark-color);
  height: 100vh;
  overflow-y: auto;
}
.dark-mode .sidebar_menu {
  background-color: var(--dark-color-off);
  color: var(--light-color);
}
.sidebar_menu .active {
  background-color: var(--light-color-off);
}
.dark-mode .sidebar_menu .active {
  background-color: var(--dark-color);
}
.logo {
  max-height: 250px;
}
.logout {
  background-color: var(--dark-color);
  color: var(--light-color);
  font-weight: bold;
}
.dark-mode .logout {
  background-color: var(--light-color);
  color: var(--dark-color);
}
.small_text {
  font-size: 15px;
  line-height: 28px;
}
.truncate {
  word-wrap: break-word;
  overflow-y: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 1;
  font-size: 18px;
  font-weight: bold;
}
.relative {
  position: relative;
}
.notification {
  position: absolute;
  background-color: red;
  width: 10px;
  height: 10px;
  top: 0;
  left: 99%;
  border-radius: 50%;
}
.pointer {
  cursor: pointer;
}
.pointer:hover {
  text-decoration: underline;
}
</style>
